import {findApiGroup, findApiInfo, examineApi, findAppList,queryApiInfoByKeyWord} from '@/service/api';
import {IApiState, IApiList, IApiInfo, IApplicationList,IApiArray} from '@/typings/authAudit';
import { Module } from 'vuex';
import { IGlobalState } from '..';
import * as Types from '../action-types';


const state: IApiState = {
    keyWord:'',
    page:1,
    pageCount:0,
    totalRows:0,
    examineResult:false,
    apiInfo:[],
    apiList:[],
    apiArray:[]
};

const application: Module<IApiState, IGlobalState> = {
    namespaced: true,
    state,
    mutations: {
        [Types.SET_APILIST](state, payload: IApiList[]) {
            state.apiList = payload;
        },
        [Types.SET_APIINFO](state, payload: IApiInfo[]) {
            state.apiInfo = payload;
        },
        [Types.SET_APISEARCHARRAY](state, payload: IApiArray[]) {
            state.apiArray = payload;
        },
        [Types.SET_EXAMINEAPIRESULT](state,data) {
            state.examineResult = data;
        },
        [Types.SET_APIPAGECOUNT](state,data) {
            state.pageCount = data;
        },
        [Types.SET_APITOTALROWS](state,data) {
            state.totalRows = data;
        }
    },
    actions: {
        // 获取api集合
        async [Types.SET_APILIST]({commit}, params) {
            let result = await findApiGroup(params);
            let apiList: IApiList[] = result.data;
            commit(Types.SET_APILIST, apiList);
        },
        // 根据id获取api信息
        async [Types.SET_APIINFO]({commit}, params) {
            let result = await findApiInfo(params);
            let apiInfo: IApiInfo[] = result.data;
            commit(Types.SET_APIINFO, apiInfo);
        },
        // 审核api
        async [Types.SET_AUDITAPI]({commit}, params) {
            let result = await examineApi(params);
            let examineResult=result.code==1;
            commit(Types.SET_EXAMINEAPIRESULT, examineResult);
        },
        // 模糊搜索获取api列表
        async [Types.SET_FUZZYSEARCHAPI]({ commit },params) {
            let result = await queryApiInfoByKeyWord(params);
            let apiaArray: IApiArray[] = result.data.rows;
            let pageCount = result.data.page_count;
            let totalRows = result.data.total_rows;
            commit(Types.SET_APISEARCHARRAY, apiaArray);
            commit(Types.SET_APIPAGECOUNT, pageCount);
            commit(Types.SET_APITOTALROWS, totalRows);
        },
    }
};
export default application;